export interface Theme {
    colors: {
        background: string;
        surface: string;
        surfaceElevated: string;
        primary: string;
        success: string;
        danger: string;
        text: string;
        textSecondary: string;
        textMuted: string;
        border: string;
        borderLight: string;
        modalBackground: string;
        modalOverlay: string;
        buttonBackground: string;
        buttonText: string;
        cardShadow: string;
        switchTrack: {
            false: string;
            true: string;
        };
        switchThumb: string;
    };
}

export const lightTheme: Theme = {
    colors: {
        background: '#FFFFFF',
        surface: '#F5F5F5',
        surfaceElevated: '#FFFFFF',
        primary: '#007AFF',
        success: '#34C759',
        danger: '#FF3B30',
        text: '#333333',
        textSecondary: '#666666',
        textMuted: '#999999',
        border: '#CCCCCC',
        borderLight: '#E5E5E5',
        modalBackground: 'rgba(0,0,0,0.95)',
        modalOverlay: 'rgba(0,0,0,0.7)',
        buttonBackground: '#007AFF',
        buttonText: '#FFFFFF',
        cardShadow: 'rgba(0,0,0,0.1)',
        switchTrack: {
            false: '#767577',
            true: '#34C759',
        },
        switchThumb: '#f4f3f4',
    },
};

export const darkTheme: Theme = {
    colors: {
        background: '#000000',
        surface: '#06071aff',
        surfaceElevated: '#1C1C1E',
        primary: '#0A84FF',
        success: '#30D158',
        danger: '#FF453A',
        text: '#FFFFFF',
        textSecondary: '#AAAAB0',
        textMuted: '#636366',
        border: '#38383A',
        borderLight: '#2C2C2E',
        modalBackground: 'rgba(0,0,0,0.95)',
        modalOverlay: 'rgba(0,0,0,0.7)',
        buttonBackground: '#0A84FF',
        buttonText: '#FFFFFF',
        cardShadow: 'rgba(0,0,0,0.3)',
        switchTrack: {
            false: '#39393D',
            true: '#30D158',
        },
        switchThumb: '#f4f3f4',
    },
};

export const getSystemTheme = (): 'light' | 'dark' => {
    if (typeof window !== 'undefined' && window.matchMedia) {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return 'light';
};

export const getCurrentTheme = (): Theme => {
    const colorScheme = getSystemTheme();
    return colorScheme === 'dark' ? darkTheme : lightTheme;
};
